export default {
  label: "Language",
  options: {
    en: "English",
    ru: "Russian",
  },
};
